import { JoonUIColor, SPACING } from "@joonapp/web-shared"

const CustomTextArea2 = ({
  value,
  onChange,
  onBlur,
  onKeyDown,
  disabled,
  placeholder,
  maxLength,
  name,
  style,
  hideBorder,
  defaultRows = 2,
  fullWidth = false,
}: {
  value: string
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
  onBlur?: () => void
  onKeyDown?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void
  disabled?: boolean
  placeholder?: string
  maxLength?: number
  name?: string
  style?: React.CSSProperties
  hideBorder?: boolean
  defaultRows?: number
  fullWidth?: boolean
  className?: string
}) => {
  return (
    <div
      style={{
        display: "flex",
        paddingLeft: SPACING.space2,
        width: fullWidth ? "100%" : "auto",
        background: JoonUIColor.background.xlightGray,
        border: hideBorder ? "none" : `1px solid ${JoonUIColor.border.default}`,
        borderRadius: SPACING.space2,
        height: "100%",
      }}
    >
      <textarea
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        maxLength={maxLength}
        disabled={disabled}
        rows={defaultRows}
        autoComplete="off"
        style={{
          display: "block",
          overflow: "auto",
          resize: "none",
          fontWeight: "400",
          minHeight: `${defaultRows * 1.5}em`,
          fontFamily: "Rubik",
          width: "100%",
          color: JoonUIColor.text.primary,
          fontSize: "14px",
          outline: "none",
          ...style,
        }}
      />
    </div>
  )
}

export default CustomTextArea2
